// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Connection } from '@shared/commons/Connection';
import { UserKey } from '@shared/commons/UtilsClasses/UserKey';
import { WorkSpaceUserKey } from '@shared/commons/UtilsClasses/WorkSpaceUserKey';
import { Md5 } from 'ts-md5';
class _UserManager {
    getBeforeLoginKey(clientType = null) {
        var _a;
        const type = (_a = clientType === null || clientType === void 0 ? void 0 : clientType.toString()) !== null && _a !== void 0 ? _a : '';
        return Md5.hashStr(`BeforeLoginKey${type}`);
    }
    getUserKey(clientType = null) {
        var _a, _b, _c, _d, _e;
        const login = (_b = (_a = Connection === null || Connection === void 0 ? void 0 : Connection.vendor) === null || _a === void 0 ? void 0 : _a.login) !== null && _b !== void 0 ? _b : null;
        const connectionName = (_e = (_d = (_c = Connection === null || Connection === void 0 ? void 0 : Connection.vendor) === null || _c === void 0 ? void 0 : _c.loginParams) === null || _d === void 0 ? void 0 : _d.connectionName) !== null && _e !== void 0 ? _e : null;
        if (!login || !connectionName) {
            return null;
        }
        const wuk = new UserKey(login, connectionName, clientType);
        return wuk.getKey();
    }
    getWorkSpaceKey(storageType) {
        var _a, _b, _c, _d, _e;
        const login = (_b = (_a = Connection === null || Connection === void 0 ? void 0 : Connection.vendor) === null || _a === void 0 ? void 0 : _a.login) !== null && _b !== void 0 ? _b : null;
        const connectionName = (_e = (_d = (_c = Connection === null || Connection === void 0 ? void 0 : Connection.vendor) === null || _c === void 0 ? void 0 : _c.loginParams) === null || _d === void 0 ? void 0 : _d.connectionName) !== null && _e !== void 0 ? _e : null;
        if (!login || !connectionName) {
            return null;
        }
        const wuk = new WorkSpaceUserKey(login, connectionName, storageType);
        return wuk.getKey();
    }
}
export const UserManager = new _UserManager();
